import React from "react"
import { useDeleteList } from "../hooks/useDeleteList"
import { toast } from "react-toastify"
import { isAxiosError } from "axios"
import { Modal } from "react-bootstrap"
import { VesselTrackingList } from "../hooks/useFetchList"

export interface VesselDeleteListModalProps {
  listID: string
  showDelete: boolean
  setShowDelete: React.Dispatch<React.SetStateAction<boolean>>
  fetchVesselTrackingList: () => Promise<void>
  activeListId: string
  setActiveList: React.Dispatch<
    React.SetStateAction<VesselTrackingList | undefined>
  >
}

function VesselDeleteListModal({
  listID,
  showDelete,
  setShowDelete,
  fetchVesselTrackingList,
  activeListId,
  setActiveList,
}: VesselDeleteListModalProps) {
  // Function to handle deleting a list
  const { deleteList, isDeleteListLoading } = useDeleteList()
  const handleClose = () => {
    setShowDelete(false)
  }
  const handleDeleteList = async () => {
    if (isDeleteListLoading) return
    try {
      await deleteList(listID)
      toast.success("List deleted successfully", {
        position: "bottom-right",
        autoClose: 8000,
      })
    } catch (err: unknown) {
      const message = "Unable to delete list"
      console.error(message, err)
      if (isAxiosError(err)) {
        toast.error(message, {
          position: "bottom-right",
          autoClose: 8000,
        })
      }
    } finally {
      setShowDelete(false)
      setActiveList(undefined)
      await fetchVesselTrackingList()
    }
  }
  return (
    <Modal show={showDelete} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Delete List</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        Are you sure you want to delete this list? This action cannot be undone.
        All favourite vessels in this list will be removed as well.
      </Modal.Body>
      <Modal.Footer>
        <button
          type="button"
          className="btn btn-secondary"
          onClick={handleClose}
          disabled={isDeleteListLoading}
        >
          Cancel
        </button>
        <button
          type="button"
          className="btn btn-danger"
          onClick={() => handleDeleteList()}
          disabled={isDeleteListLoading}
        >
          {isDeleteListLoading ? "Deleting..." : "Delete List"}
        </button>
      </Modal.Footer>
    </Modal>
  )
}

export default VesselDeleteListModal
